<template>
  <div>
    <EditForm
      ref="editForm"
      :disabled="disabled"
      :pdTechDictCode="pdTechDictCode"
      @closeEdit="closeDetail"
    />
    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <el-button
        type="primary"
        size="small"
        @click="() => $refs.editForm.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import EditForm from '../components/edit-form'
export default {
  name: 'technology-processTechnical-detail',
  components: { EditForm },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    pdTechDictCode: {
      type: String,
      default: '',
    },
  },
  methods: {
    closeDetail() {
      this.$emit('closeDetail')
    },
  },
}
</script>
